// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1SQco","errorLogs":"styles_errorLogs__vwD7q"};